import { restartableTask } from 'ember-concurrency';
import IntlService from 'ember-intl/services/intl';
import { IResourceName } from 'volta/models/base-model';
import Task, { TaskResourceNameFromParentRecordResourceName } from 'volta/models/task';
import BvFlashService from 'volta/services/bv-flash';
import StoreService from 'volta/services/store';
import TaskService from 'volta/services/task-service';
import { defaultErrorHandler } from 'volta/utils/error-utils';

import { inject as service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

interface IArgs {
  entityId: string;
  resourceName: IResourceName;
  onSave?: (comment: Task) => void;
}

export default class CommentForm extends Component<IArgs> {
  @service store!: StoreService;
  @service taskService!: TaskService;
  @service bvFlash!: BvFlashService;
  @service intl!: IntlService;

  @tracked value?: string;

  submitCommentTask = restartableTask(async (value: string) => {
    if (!this.value) {
      return;
    }
    try {
      const { entityId } = this.args;
      const body = `${value}`.trim();

      if (isEmpty(body) || !entityId) {
        return;
      }

      const TaskResourceName = TaskResourceNameFromParentRecordResourceName(this.args.resourceName);

      if (!TaskResourceName) {
        throw new Error(this.intl.t('dashboardPage.errors.missingResourceName'));
      }

      const payload = this.store.createRecord(TaskResourceName.singular, {
        comment: body,
        linkedEntityId: entityId,
        taskType: 'COMMENT'
      });

      const createdComment = await this.taskService.saveTask.perform(payload);

      this.args.onSave?.(createdComment);
      this.value = undefined;
      return createdComment;
    } catch (error) {
      defaultErrorHandler(error);
      this.bvFlash.error(error);
      return;
    }
  });
}
